export type GenStartButtonAction =
  | 'do-nothing'
  | 'open-trial-pay-modal'
  | 'continue-generation'
  | 'open-pricing-modal'
  | 'open-credit-purchase-modal';

export type GenStartPostLoginAction =
  | 'continue-after-login'
  | GenStartButtonAction;

export type LaunchOrderPostLoginAction =
  | 'do-nothing'
  | 'continue-generation'
  | 'open-pricing-modal'
  | 'open-credit-purchase-modal';

interface GenStartPostLoginActionInput {
  hasReachedTrialPayJourney: boolean;
  isFreeUser: boolean;
  hasPaidTrialPack: boolean;
  userPoints: number | undefined;
}

interface LaunchOrderPostLoginActionInput {
  isCurrentProject: boolean;
  isCurrentRoute: boolean;
  isLaunchOrderPending: boolean;
  isFreeUser: boolean;
  hasPaidTrialPack: boolean;
  userPoints: number | undefined;
}

export function getGenStartButtonAction(input: Omit<GenStartPostLoginActionInput, 'hasReachedTrialPayJourney'>): GenStartButtonAction {
  return getGenStartPostLoginAction({
    ...input,
    hasReachedTrialPayJourney: true,
  }) as GenStartButtonAction;
}

export function getGenStartPostLoginAction(input: GenStartPostLoginActionInput): GenStartPostLoginAction {
  if (!input.hasReachedTrialPayJourney) {
    return 'continue-after-login';
  }

  if (input.isFreeUser) {
    if (!input.hasPaidTrialPack) {
      return 'open-trial-pay-modal';
    }

    if (input.userPoints === undefined) {
      return 'do-nothing';
    }

    return input.userPoints > 0
      ? 'continue-generation'
      : 'open-pricing-modal';
  }

  if (input.userPoints === undefined) {
    return 'do-nothing';
  }

  return input.userPoints > 0
    ? 'continue-generation'
    : 'open-credit-purchase-modal';
}

export function getLaunchOrderPostLoginAction(
  input: LaunchOrderPostLoginActionInput,
): LaunchOrderPostLoginAction {
  if (!input.isCurrentProject || !input.isCurrentRoute || !input.isLaunchOrderPending) {
    return 'do-nothing';
  }

  if (input.isFreeUser) {
    if (!input.hasPaidTrialPack || input.userPoints === undefined) {
      return 'do-nothing';
    }

    return input.userPoints > 0
      ? 'continue-generation'
      : 'open-pricing-modal';
  }

  if (input.userPoints === undefined) {
    return 'do-nothing';
  }

  return input.userPoints > 0
    ? 'continue-generation'
    : 'open-credit-purchase-modal';
}

const PREPAY_CTA_SHOW_SESSION_KEY = 'wegic:prepay-cta-show-requested';

export function shouldRequestPrepayCtaShow(storage: Storage = sessionStorage) {
  if (storage.getItem(PREPAY_CTA_SHOW_SESSION_KEY)) {
    return false;
  }

  storage.setItem(PREPAY_CTA_SHOW_SESSION_KEY, '1');
  return true;
}

export function normalizeReferenceUiImageUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.search.includes('imageMogr2/format/webp')) {
      parsedUrl.search = '';
      return parsedUrl.toString();
    }
  } catch {
    // Fall through to string cleanup for relative or malformed URLs.
  }

  return url.replace(/\?imageMogr2\/format\/webp$/, '');
}
